// extracted by mini-css-extract-plugin
export default {"image_section":"UnderConstructionTest_image_section__0+ZFi","content_section":"UnderConstructionTest_content_section__AtE8D"};